import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { X, Cookie, Settings } from 'lucide-react';

export const ConsentBanner: React.FC = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptAll = () => {
    // Grant all consents
    const w = window as any;
    if (typeof w.gtag === 'function') {
      w.gtag('consent', 'update', {
        'ad_storage': 'granted',
        'analytics_storage': 'granted',
        'ad_user_data': 'granted',
        'ad_personalization': 'granted'
      });
    }
    localStorage.setItem('cookie-consent', JSON.stringify({
      analytics: true,
      marketing: true,
      functional: true,
      timestamp: Date.now()
    }));
    setShowBanner(false);
  };

  const acceptNecessary = () => {
    // Grant only necessary consents
    const w = window as any;
    if (typeof w.gtag === 'function') {
      w.gtag('consent', 'update', {
        'ad_storage': 'denied',
        'analytics_storage': 'granted',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied'
      });
    }
    localStorage.setItem('cookie-consent', JSON.stringify({
      analytics: true,
      marketing: false,
      functional: true,
      timestamp: Date.now()
    }));
    setShowBanner(false);
  };

  const deny = () => {
    // Deny all non-essential consents
    const w = window as any;
    if (typeof w.gtag === 'function') {
      w.gtag('consent', 'update', {
        'ad_storage': 'denied',
        'analytics_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied'
      });
    }
    localStorage.setItem('cookie-consent', JSON.stringify({
      analytics: false,
      marketing: false,
      functional: true,
      timestamp: Date.now()
    }));
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-background border-t shadow-lg p-4">
      <div className="container mx-auto max-w-6xl">
        <div className="flex items-start gap-4">
          <Cookie className="h-6 w-6 text-primary flex-shrink-0 mt-1" />
          <div className="flex-1">
            <h3 className="font-semibold mb-2">Cookies en Privacy</h3>
            <p className="text-sm text-muted-foreground mb-4">
              We gebruiken cookies om uw ervaring te verbeteren, website gebruik te analyseren en voor affiliate marketing via Daisycon. 
              Door "Accepteren" te klikken, stemt u in met ons gebruik van alle cookies inclusief affiliate tracking.
            </p>
            
            {showDetails && (
              <div className="mb-4 p-3 bg-muted/50 rounded-lg text-sm">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <h4 className="font-medium mb-1">Functionele Cookies</h4>
                    <p className="text-muted-foreground">Noodzakelijk voor het functioneren van de website</p>
                  </div>
                  <div>
                    <h4 className="font-medium mb-1">Analytische Cookies</h4>
                    <p className="text-muted-foreground">Helpen ons de website te verbeteren door bezoekersstatistieken</p>
                  </div>
                  <div>
                    <h4 className="font-medium mb-1">Marketing & Affiliate Cookies</h4>
                    <p className="text-muted-foreground">Voor advertenties, affiliate tracking (Daisycon) en B2B analyse</p>
                  </div>
                </div>
              </div>
            )}
            
            <div className="flex flex-wrap gap-2">
              <Button onClick={acceptAll} className="bg-primary hover:bg-primary/90">
                Alle Cookies Accepteren
              </Button>
              <Button onClick={acceptNecessary} variant="outline">
                Alleen Noodzakelijke
              </Button>
              <Button 
                onClick={() => setShowDetails(!showDetails)} 
                variant="ghost" 
                size="sm"
                className="text-muted-foreground"
              >
                <Settings className="h-4 w-4 mr-1" />
                {showDetails ? 'Verberg Details' : 'Meer Info'}
              </Button>
            </div>
          </div>
          <Button
            onClick={deny}
            variant="ghost"
            size="sm"
            className="text-muted-foreground p-2"
            aria-label="Cookies weigeren en banner sluiten"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConsentBanner;